<template>
  <v-container class="pa-0">
    <v-data-table
    dense
        :headers="headers"
        :items="list"
        :page.sync="page"
        :items-per-page="20"
        hide-default-footer
        :search="search"
    >
        <template v-slot:item="props">
        <tr>
            <td class="text-center pa-2">{{ props.item.numero }}</td>
            <td class="text-center pa-2">{{ props.item.dt_emissao | formatDate }}</td>
            <td class="text-right pa-2">{{ props.item.valor | formatPrice }}</td>
            <td class="text-center pa-2">
                <a style="color:#118ACA;cursor:pointer" :href="props.item.link" target="_blank">{{ props.item.link }}</a>
            </td>
            <!-- <td class="text-center pa-2">
                <a style="text-decoration:none" href="">{{ props.item.anexo }}</a>
            </td> -->
            <td class="text-center pa-2">
              {{ props.item.lotes }}
              <v-btn :disabled="showParam || (parameter && parameter.status!='F' && !!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO)" v-if="!props.item.integrada" small color="primary lighten-2" icon>
                <v-icon v-if="userData.PermissaoAcoes.faturamento.includes('updatenotafiscal')" @click="assocItem(props.item)" small>fa-plus</v-icon>
                <v-icon v-else @click="userInfo()" small>fa-plus</v-icon>
              </v-btn>
              <v-tooltip v-else-if="parameter.status!='F'" center bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="showParam"
                    color="#94999C"
                    x-small
                    icon
                    v-bind="attrs"
                    v-on="on"
                  ><v-icon small>fa-plus</v-icon>
                  </v-btn>
                </template>
                <span class="pa-5">Nota fiscal já integrada com a operadora</span>
              </v-tooltip>
            </td>
            <td class="text-center pa-2">
                <v-tooltip bottom v-if="props.item.doc_id">
                  <template v-slot:activator="{ on, attrs }" >
                    <span v-bind="attrs" v-on="on" class="pa-0">
                        <v-btn small color="primary lighten-2" icon @click="getDocument({doc_id: props.item.doc_id, nome: props.item.anexo})">
                            <v-icon small>fa-download</v-icon>
                        </v-btn>
                    </span>
                  </template>
                  <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">
                      {{props.item.anexo}}
                  </span>
                </v-tooltip>
            </td>
            <td class="text-center pa-2">
                
            <v-btn :disabled="showParam || (parameter.status!='F' && !!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO)" v-if="!props.item.integrada" small color="primary lighten-2" icon>
                <v-icon v-if="userData.PermissaoAcoes.faturamento.includes('updatenotafiscal')" @click="editItem(props.item.id)" small>fa-pencil-alt</v-icon>
                <v-icon v-else @click="userInfo()" small>fa-pencil-alt</v-icon>
            </v-btn> 
            <v-tooltip v-else center bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="showParam"
                    color="#94999C"
                    x-small
                    icon
                    v-bind="attrs"
                    v-on="on"
                  ><v-icon small>fa-pencil-alt</v-icon>
                  </v-btn>
                </template>
                <span class="pa-5">Nota fiscal já integrada com a operadora</span>
              </v-tooltip>
            </td>
            <td class="text-center pa-2">
            <v-btn :disabled="showParam" v-if="props.item.lotes==0 && props.item.integrada==0" small color="primary lighten-2" icon>
                <v-icon v-if="userData.PermissaoAcoes.faturamento.includes('deletenotafiscal')" @click="delItem(props.item)" small>mdi-delete</v-icon>
                <v-icon v-else @click="userInfo()" small>mdi-delete</v-icon>
            </v-btn>
            <v-tooltip v-else center bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="showParam"
                    color="#94999C"
                    x-small
                    icon
                    v-bind="attrs"
                    v-on="on"
                  ><v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span class="pa-5">{{props.item.integrada?'Nota fiscal já integrada com a operadora': 'Esta nota fiscal possui lotes associados'}}</span>
              </v-tooltip>
            </td>
        </tr>
        </template>
    </v-data-table>
    <v-col class="text-center" cols="12">
        <v-pagination class="no-box-shadow" v-model="page" :length="totalPages()"></v-pagination>
    </v-col>
  </v-container>
</template>

<script>
import { mapActions } from "vuex"
import moment from 'moment'
export default {
    data(){
        return {
            page: 1,
            showParam: false
        }
    },
    filters: {
        formatDate(date) {
        return moment(date).format("L");
        },
        formatPrice(value) {
            let val = (value/1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }
    },
    watch: {
      parameter(param) {
        if (param.config.FAT_NOTA_FISCAL_CAMPOS_OBRIGATORIOS && param.status=='F') 
          this.showParam = true
      }
    },
    methods: {
      ...mapActions({
        getDocument: "documents/getDocument"
      }),
      totalPages(){
        let total = this.list? parseInt(this.list.length/20) : 1
        total = total % 20  > 0 ? total++ : total
        return total == 0? 1 : total
      },
      userInfo() {
        let paramModal = {
          type: "error",
          title: "Atenção!",
          message: "Você não possui permissão para executar esta ação. <br/> Contacte o seu gestor.",
          callback: null,
          btConfirm: { name: "Fechar", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
    },
    props: {
        headers: Array,
        list: Array,
        pagination: Object,
        getList: Function,
        delItem: Function,
        editItem: Function,
        assocItem: Function,
        getFile: Function,
        search: String,
        userData: Object,
        parameter: Object
    }
}
</script>

<style>
.no-box-shadow, .no-box-shadow *{
  box-shadow: 0 0 0 0!important;
}
</style>